"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "17.5",
    viewBox: "0 0 30 17.5"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M29,11h-8.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h8V1h-8C20.2,1,20,0.8,20,0.5S20.2,0,20.5,0H29 c0.3,0,0.5,0.2,0.5,0.5v10C29.5,10.8,29.3,11,29,11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M9.5,11H1c-0.3,0-0.5-0.2-0.5-0.5v-10C0.5,0.2,0.7,0,1,0h8.5C9.8,0,10,0.2,10,0.5S9.8,1,9.5,1h-8v9h8 c0.3,0,0.5,0.2,0.5,0.5S9.8,11,9.5,11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M29.5,13h-29C0.2,13,0,12.8,0,12.5S0.2,12,0.5,12h29c0.3,0,0.5,0.2,0.5,0.5S29.8,13,29.5,13z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M4,17.5c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4C4.5,17.3,4.3,17.5,4,17.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    stroke: "#EC6833",
    d: "M24.9,17"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    stroke: "#EC6833",
    d: "M24.9,13"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M27,17.5c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4 C27.5,17.3,27.3,17.5,27,17.5z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#EC6833",
    cx: "15",
    cy: "5.2",
    r: "4.3"
  }));
};

exports["default"] = _default;